import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const OBGYNDoctor: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    width={350}
    height={350}
    viewBox="0 0 350 350"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_3690_7903"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="350"
      height="350"
    >
      <path d="M350 0H0V350H350V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_3690_7903)">
      <path
        d="M119.044 278.419C118.351 278.366 117.634 278.339 116.985 278.585C116.222 278.873 115.642 279.505 115.158 280.162C112.342 283.986 111.923 289.013 111.653 293.754C110.487 314.202 110.949 321.875 115.707 345.157C118.45 358.582 125.101 413.802 126.997 413.802C134.66 413.802 210.867 413.023 218.084 413.023C219.908 371.116 234.408 328.293 232.362 286.389C232.276 284.617 231.221 282.796 230.479 281.186C226.393 272.317 125.073 278.883 119.044 278.419Z"
        fill="#002677"
      />
      <mask
        id="mask1_3690_7903"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="111"
        y="276"
        width="122"
        height="138"
      >
        <path
          d="M119.044 278.419C118.351 278.366 117.634 278.339 116.985 278.585C116.222 278.873 115.642 279.505 115.158 280.162C112.342 283.986 111.923 289.013 111.653 293.754C110.487 314.202 110.949 321.875 115.707 345.157C118.45 358.582 125.101 413.802 126.997 413.802C134.66 413.802 210.867 413.023 218.084 413.023C219.908 371.116 234.408 328.293 232.362 286.389C232.276 284.617 231.221 282.796 230.479 281.186C226.393 272.317 125.073 278.883 119.044 278.419Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_3690_7903)">
        <path
          d="M199.528 320.634C199.528 320.654 199.528 419.528 199.528 419.528C210.205 419.528 211.021 419.884 221.445 417.576C222.093 417.432 222.783 417.253 223.219 416.752C223.657 416.249 223.738 415.537 223.799 414.873C224.831 403.702 225.865 392.533 226.897 381.362C226.796 382.408 248.43 275.977 236.898 277.023C238.764 276.854 206.734 280.677 198.889 286.164C194.229 289.423 196.251 295.766 196.712 300.821C197.3 307.271 199.528 314.23 199.528 320.634Z"
          fill="#000C44"
        />
      </g>
    </g>
    <mask
      id="mask2_3690_7903"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="350"
      height="350"
    >
      <path d="M350 0H0V350H350V0Z" fill="white" />
    </mask>
    <g mask="url(#mask2_3690_7903)">
      <path
        d="M218.732 139.811C212.161 135.213 204.842 131.876 197.577 128.738C195.074 127.657 192.418 126.556 189.726 126.744C187.706 122.488 186.608 117.059 187.419 107.581H151.297C152.149 117.536 150.895 123.025 148.678 127.378C148.562 127.328 148.439 127.282 148.302 127.243C147.153 126.921 145.935 127.288 144.808 127.68C133.48 131.628 123.308 138.702 115.164 147.469C105.1 158.303 98.4461 171.717 93.6233 185.582C88.3035 200.876 84.4933 216.973 81.4482 232.867C81.8257 230.898 91.8521 231.79 97.2987 233.06C110.345 235.492 117.352 240.431 117.352 240.431C116.266 247.969 116.16 255.447 115.141 262.497C113.932 270.857 110.953 279.318 110.53 287.779C110.325 291.882 110.162 296.197 112.005 299.869C114.492 304.823 119.963 307.393 125.045 309.605C138.161 315.317 148.528 318.601 163.191 323.921C166.101 318.645 168.77 315.126 172.534 308.956C175.846 313.294 178.503 317.78 183.4 324.22C190.52 320.627 201.166 315.618 208.421 312.307C223.186 305.569 231.368 299.047 232.15 297.232C233.246 294.691 233.386 291.743 233.254 289.019C233.034 284.493 232.029 280.128 231.214 275.692C230.365 271.068 229.595 266.415 229.344 261.715C229.218 259.359 229.121 256.785 229.876 254.513C231.578 249.394 236.814 245.208 240.926 242.074C247.554 237.023 255.064 232.789 262.712 229.471L270.43 223.103C252.232 199.851 244.881 158.108 218.732 139.811Z"
        fill="#0072A6"
      />
      <mask
        id="mask3_3690_7903"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="81"
        y="107"
        width="190"
        height="218"
      >
        <path
          d="M218.732 139.811C212.161 135.213 204.842 131.876 197.577 128.738C195.074 127.657 192.418 126.556 189.726 126.744C187.706 122.488 186.608 117.059 187.419 107.581H151.297C152.149 117.536 150.895 123.025 148.678 127.378C148.562 127.328 148.439 127.282 148.302 127.243C147.153 126.921 145.935 127.288 144.808 127.68C133.48 131.628 123.308 138.702 115.164 147.469C105.1 158.303 98.4461 171.717 93.6233 185.582C88.3035 200.876 84.4933 216.973 81.4482 232.867C81.8257 230.898 91.8521 231.79 97.2987 233.06C110.345 235.492 117.352 240.431 117.352 240.431C116.266 247.969 116.16 255.447 115.141 262.497C113.932 270.857 110.953 279.318 110.53 287.779C110.325 291.882 110.162 296.197 112.005 299.869C114.492 304.823 119.963 307.393 125.045 309.605C138.161 315.317 148.528 318.601 163.191 323.921C166.101 318.645 168.77 315.126 172.534 308.956C175.846 313.294 178.503 317.78 183.4 324.22C190.52 320.627 201.166 315.618 208.421 312.307C223.186 305.569 231.368 299.047 232.15 297.232C233.246 294.691 233.386 291.743 233.254 289.019C233.034 284.493 232.029 280.128 231.214 275.692C230.365 271.068 229.595 266.415 229.344 261.715C229.218 259.359 229.121 256.785 229.876 254.513C231.578 249.394 236.814 245.208 240.926 242.074C247.554 237.023 255.064 232.789 262.712 229.471L270.43 223.103C252.232 199.851 244.881 158.108 218.732 139.811Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_3690_7903)">
        <path
          d="M219.004 267.835C217.168 267.37 212.893 268.031 211.021 267.738C202.995 266.481 194.814 266.833 186.697 267.188C178.274 267.557 169.85 267.926 161.433 268.437C146.118 269.365 130.831 270.763 115.601 272.628C115.203 275.017 118.256 276.338 120.648 276.718C147.66 281.005 175.544 277.139 202.418 282.217C203.958 282.508 205.533 282.844 206.846 283.7C215.473 289.319 202.523 312.445 198.686 318.388C197.599 320.072 195.987 322.72 193.753 322.97C196.626 322.639 234.748 302.999 235.156 299.22C235.677 294.391 238.586 283.254 235.233 278.662C232.978 275.574 232.731 271.911 229.226 270.385C226.183 269.059 222.221 268.651 219.004 267.835Z"
          fill="#00448A"
        />
      </g>
    </g>
    <mask
      id="mask4_3690_7903"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="350"
      height="350"
    >
      <path d="M350 0H0V350H350V0Z" fill="white" />
    </mask>
    <g mask="url(#mask4_3690_7903)">
      <path
        d="M141.676 129.103C141.733 128.586 141.82 128.073 141.935 127.566C142.012 127.227 142.093 126.888 142.204 126.558C142.255 126.405 142.329 126.256 142.359 126.099C142.39 125.937 142.4 125.797 142.485 125.645C142.506 125.606 142.531 125.568 142.567 125.541C142.6 125.517 142.639 125.504 142.678 125.492C144.496 124.914 146.563 124.73 148.462 124.803C148.359 124.799 147.809 125.573 147.704 125.68C147.464 125.925 147.257 126.068 146.959 126.217C146.212 126.591 145.554 127.197 144.847 127.649C143.895 128.257 142.815 128.98 141.676 129.103Z"
        fill="#00448A"
      />
    </g>
    <mask
      id="mask5_3690_7903"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="350"
      height="350"
    >
      <path d="M350 0H0V350H350V0Z" fill="white" />
    </mask>
    <g mask="url(#mask5_3690_7903)">
      <path
        d="M81.4481 232.868C81.867 230.676 94.231 232.027 98.944 233.499C103.657 234.972 116.203 244.477 108.923 244.477C101.642 244.477 80.3513 238.604 81.4481 232.868Z"
        fill="#00448A"
      />
    </g>
    <mask
      id="mask6_3690_7903"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="350"
      height="350"
    >
      <path d="M350 0H0V350H350V0Z" fill="white" />
    </mask>
    <g mask="url(#mask6_3690_7903)">
      <path
        d="M115.715 259.141C113.912 266.322 109.103 270.965 94.9688 269.225C81.1761 267.527 85.9615 231.778 85.9698 231.716C89.4345 231.713 94.1379 232.323 97.2988 233.06C110.345 235.492 117.352 240.431 117.352 240.431C116.733 247.016 117.061 253.784 115.715 259.141Z"
        fill="#B86121"
      />
    </g>
    <mask
      id="mask7_3690_7903"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="350"
      height="350"
    >
      <path d="M350 0H0V350H350V0Z" fill="white" />
    </mask>
    <g mask="url(#mask7_3690_7903)">
      <path
        d="M187.418 107.581C187.418 107.581 151.296 107.581 151.296 107.581C151.848 114.027 152.055 120.266 147.367 125.143C146.017 126.547 143.77 127.698 142.865 129.463C141.555 132.016 143.406 133.84 144.826 136.08C150.918 145.688 158.741 153.73 164.157 163.809C165.884 167.021 167.378 170.344 168.849 173.679C169.991 176.269 170.455 177.434 173.221 176.132C181.363 172.301 185.941 158.93 189.151 151.326C191.974 144.638 194.532 137.796 196.689 130.862C191.213 122.39 185.879 125.571 187.418 107.581Z"
        fill="#B86121"
      />
      <mask
        id="mask8_3690_7903"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="142"
        y="107"
        width="55"
        height="70"
      >
        <path
          d="M187.418 107.581C187.418 107.581 151.296 107.581 151.296 107.581C151.848 114.027 152.055 120.266 147.367 125.143C146.017 126.547 143.77 127.698 142.865 129.463C141.555 132.016 143.406 133.84 144.826 136.08C150.918 145.688 158.741 153.73 164.157 163.809C165.884 167.021 167.378 170.344 168.849 173.679C169.991 176.269 170.455 177.434 173.221 176.132C181.363 172.301 185.941 158.93 189.151 151.326C191.974 144.638 194.532 137.796 196.689 130.862C191.213 122.39 185.879 125.571 187.418 107.581Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask8_3690_7903)">
        <path
          d="M148.811 111.068C149.026 111.029 149.255 111.024 149.471 111.024C150.258 111.023 150.788 111.485 151.482 111.82C152.266 112.197 153.065 112.542 153.875 112.857C155.461 113.473 157.093 113.969 158.751 114.35C162.072 115.112 165.496 115.411 168.9 115.281C172.4 115.146 175.861 114.508 179.228 113.556C180.904 113.082 182.558 112.532 184.195 111.935C185.696 111.388 187.323 110.339 188.948 110.9C189.201 110.987 189.446 111.106 189.648 111.28C190.041 111.62 190.237 112.146 190.265 112.663C190.292 113.181 190.167 112.017 190.003 112.509C188.51 116.998 185.175 121.769 181.51 124.542C178.618 126.73 174.687 128.553 171.013 128.999C166.894 129.498 163.385 128.144 159.906 126.079C155.624 123.539 151.116 118.305 148.609 113.924C148.408 113.573 148.206 114.899 148.078 114.517C147.881 113.932 147.864 113.305 147.848 112.689C147.836 112.227 147.844 111.712 148.165 111.38C148.338 111.202 148.565 111.113 148.811 111.068Z"
          fill="#933C21"
        />
      </g>
    </g>
    <mask
      id="mask9_3690_7903"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="350"
      height="350"
    >
      <path d="M350 0H0V350H350V0Z" fill="white" />
    </mask>
    <g mask="url(#mask9_3690_7903)">
      <path
        d="M235.156 243.982C231.741 239.13 230.122 235.769 230.122 235.769C229.383 235.662 228.326 233.838 227.856 235.011C227.386 236.183 222.322 235.466 222.322 235.466C220.268 231.628 208.799 236.603 208.799 236.603L206.201 239.277C199.351 237.493 194.474 242.356 193.879 244.223C193.317 245.984 194.645 247.176 198.008 247.455C201.736 247.765 208.481 248.618 214.165 252.477L214.161 252.469C222.868 259.035 231.301 260.63 234.446 258.209C234.679 258.029 234.919 257.784 235.156 257.491V243.982Z"
        fill="#B86121"
      />
      <path
        d="M260.65 220.943C260.65 220.943 266.989 241.238 262.854 254.136C258.371 268.118 241.642 266.389 228.39 259.857C228.39 259.857 231.032 238.535 231.747 238.201C232.462 237.867 243.98 220.191 260.65 220.943Z"
        fill="#B86121"
      />
      <path
        d="M209.59 233.034C208.148 232.339 202.987 232.903 201.429 233.21C198.084 233.87 192.567 235.064 192.567 235.064C188.672 235.786 189.682 237.935 190.475 238.486C192.563 239.938 196.77 239.871 200.811 239.535C202.836 239.367 203.963 239.973 203.963 239.973C207.145 239.161 211.118 236.658 211.118 236.658L209.59 233.034Z"
        fill="#B86121"
      />
      <path
        d="M207.297 231.481C205.714 231.552 204.191 232.134 202.933 233.154C200.231 235.343 195.819 239.048 195.819 239.048C194.602 240.022 193.147 240.873 194.384 242.52C196.068 244.145 202.91 240.33 207.317 237.487C209.052 236.369 214.652 231.481 214.652 231.481H207.297Z"
        fill="#933C21"
      />
      <path
        d="M217.967 229.957C216.739 229.954 215.897 230.517 215.046 231.11C212.203 233.091 206.922 236.506 206.922 236.506C205.643 237.385 204.337 237.768 204.853 239.356C205.526 241.173 210.814 240.741 215.07 237.651C218.936 234.844 220.364 235.7 220.364 235.7L223.664 231.225C223.664 231.225 219.061 229.96 217.967 229.957Z"
        fill="#933C21"
      />
      <path
        d="M229.903 240.333C230.418 243.19 229.957 249.993 232.144 253.815L238.657 254.564C238.586 250.255 237.277 247.032 235.855 244.961C232.095 239.483 230.171 232.701 226.222 230.55L226.222 230.554C225.681 230.256 224.991 230.042 224.092 229.989C222.952 229.911 221.856 230.053 221.331 230.889C219.922 233.133 217.696 237.204 216.876 238.718C216.685 239.069 216.484 239.412 216.28 239.755C215.645 240.822 215.222 242.009 216.164 242.819C217.306 243.681 219.672 242.529 221.873 239.939C223.913 237.537 225.639 235.82 225.882 235.798C227.47 235.654 229.204 236.455 229.903 240.333Z"
        fill="#933C21"
      />
    </g>
    <mask
      id="mask10_3690_7903"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="350"
      height="350"
    >
      <path d="M350 0H0V350H350V0Z" fill="white" />
    </mask>
    <g mask="url(#mask10_3690_7903)">
      <path
        d="M244.639 256.656C244.31 256.174 243.777 255.84 243.117 255.84H210.954H127.158H94.9951C94.3368 255.84 93.8053 256.172 93.4755 256.652C93.093 257.208 93.1804 257.986 93.6205 258.493L105.873 272.591L231.362 272.593C231.885 272.593 232.384 272.362 232.739 271.955L244.496 258.493C244.934 257.987 245.02 257.213 244.639 256.656Z"
        fill="#D2C8BE"
      />
      <path
        d="M243.609 251.878H94.5037C92.896 251.878 91.5928 253.258 91.5928 254.96C91.5928 255.726 91.8583 256.426 92.2963 256.964C92.3238 256.998 92.8261 257.577 93.6213 258.493C93.1804 257.985 93.0932 257.207 93.4775 256.649C93.8074 256.171 94.3382 255.84 94.9953 255.84H127.158H210.954H243.117C243.776 255.84 244.308 256.172 244.638 256.653C245.02 257.211 244.934 257.987 244.495 258.495C245.277 257.591 245.765 257.026 245.782 257.007C246.24 256.463 246.52 255.746 246.52 254.96C246.52 253.258 245.216 251.878 243.609 251.878Z"
        fill="#EBE6E1"
      />
      <path
        d="M221.491 255.186H228.455C229.211 255.186 229.824 254.573 229.824 253.817C229.824 253.06 229.211 252.447 228.455 252.447H221.491C220.734 252.447 220.121 253.06 220.121 253.817C220.121 254.573 220.734 255.186 221.491 255.186Z"
        fill="#D2C8BE"
      />
    </g>
    <mask
      id="mask11_3690_7903"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="350"
      height="350"
    >
      <path d="M350 0H0V350H350V0Z" fill="white" />
    </mask>
    <g mask="url(#mask11_3690_7903)">
      <path
        d="M125.298 263.023C125.156 262.067 124.255 261.304 122.891 260.999C122.889 260.943 122.888 260.886 122.883 260.828C122.757 259.488 121.145 258.425 118.796 258.425C116.09 258.348 108.979 259.029 108.979 259.029C108.979 259.029 90.9743 260.368 86.2399 255.623C86.2399 255.623 84.4806 257.658 83.7794 259.464C82.632 262.42 83.6098 263.289 84.272 264.738C84.4305 265.085 84.3974 265.502 84.3486 265.872C84.2826 266.372 84.1643 266.863 84.0772 267.359C83.8845 268.457 83.8365 269.635 84.4828 270.585C84.8081 271.064 85.2572 271.452 85.7556 271.714C86.3559 272.03 86.7922 272.017 87.1866 272.36C88.1689 273.214 87.6551 274.677 88.9566 275.746C89.4602 276.136 90.1554 276.319 90.4534 276.386C91.3942 276.548 92.5493 276.511 93.4365 276.427C93.4365 276.427 93.5228 276.514 93.4365 276.427C96.133 279.159 100.173 278.011 103.119 276.469C106.415 274.744 109.418 272.434 112.47 270.283C113.709 269.409 114.963 268.509 116.272 267.732C117.976 267.155 120.101 266.306 121.993 265.74C124.685 264.899 125.516 264.498 125.298 263.023Z"
        fill="#933C21"
      />
    </g>
    <mask
      id="mask12_3690_7903"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="350"
      height="350"
    >
      <path d="M350 0H0V350H350V0Z" fill="white" />
    </mask>
    <g mask="url(#mask12_3690_7903)">
      <path
        d="M84.4285 269.543C84.8237 269.964 85.3302 270.246 85.886 270.326C87.1351 270.505 89.3091 270.279 91.5445 269.545C92.4386 269.23 93.1607 268.901 93.6894 268.631L93.7096 268.621C94.0857 268.429 94.0324 267.845 93.6285 267.732L84.415 265.286C84.2804 266.315 83.7667 267.507 84.0152 268.75C84.0742 269.045 84.2186 269.318 84.4186 269.532C84.4219 269.536 84.4252 269.539 84.4285 269.543Z"
        fill="#B86121"
      />
    </g>
    <mask
      id="mask13_3690_7903"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="350"
      height="350"
    >
      <path d="M350 0H0V350H350V0Z" fill="white" />
    </mask>
    <g mask="url(#mask13_3690_7903)">
      <path
        d="M90.9742 255.7C90.9742 255.7 91.9188 257.203 97.7652 257.442C103.26 257.668 106.061 257.083 109.735 256.631C111.879 256.367 116.507 256.491 115.405 259.602C114.837 261.205 106.762 261.989 100.707 263.375C96.7571 264.278 94.6689 262.841 85.9029 261.285C83.9418 260.937 83.5157 259.905 83.3059 258.955C83.1691 258.335 83.0274 256.38 84.4801 255.186C85.0951 254.681 86.1264 253.862 87.3295 254.297L90.9742 255.7Z"
        fill="#B86121"
      />
    </g>
    <mask
      id="mask14_3690_7903"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="350"
      height="350"
    >
      <path d="M350 0H0V350H350V0Z" fill="white" />
    </mask>
    <g mask="url(#mask14_3690_7903)">
      <path
        d="M142.832 125.388C143.064 125.323 143.211 125.322 143.545 125.26C143.339 125.634 143.37 126.185 143.399 126.598C143.432 127.067 143.534 127.529 143.673 127.978C143.954 128.883 144.385 129.732 144.804 130.58C146.159 133.32 148.525 135.755 150.45 138.142C154.505 143.174 158.948 147.881 163.025 152.883C164.763 155.015 174.151 174.388 173.16 177.281C172.341 177.698 171.306 177.416 170.593 176.837C169.879 176.258 169.418 175.433 168.974 174.628C166.068 169.367 162.836 164.295 159.919 159.04C159.386 157.974 159.008 157.132 158.257 156.177C157.631 155.382 156.768 153.967 155.814 153.549C154.82 153.114 152.912 153.55 152.042 154.102C151.011 154.757 150.421 155.945 149.422 156.649C149.076 156.893 148.635 157.078 148.235 156.938C148.058 156.877 147.907 156.757 147.764 156.635C145.403 154.633 144.235 151.683 142.734 149.006C141.135 146.153 139.552 143.278 138.318 140.244C137.439 138.082 134.819 132.971 135.381 130.602C135.623 129.577 137.091 128.677 137.863 128.078C139.116 127.107 140.518 126.422 141.948 125.731C142.233 125.594 142.528 125.473 142.832 125.388Z"
        fill="#0072A6"
      />
    </g>
    <mask
      id="mask15_3690_7903"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="350"
      height="350"
    >
      <path d="M350 0H0V350H350V0Z" fill="white" />
    </mask>
    <g mask="url(#mask15_3690_7903)">
      <path
        d="M152.344 158.244C153.192 158.182 154.003 158.373 154.827 159.141C155.456 159.727 155.7 160.54 156.131 161.257C156.581 162.007 157.097 162.767 157.667 163.438C158.856 164.836 160.328 165.96 161.783 167.064C162.689 167.752 163.594 168.44 164.5 169.128C165.79 170.107 167.131 171.111 168.708 171.478C168.396 169.598 166.91 168.155 165.736 166.755C164.381 165.138 163.105 163.454 161.958 161.683C160.178 158.936 159.011 154.288 156.079 152.533C153.522 151.001 152.158 153.485 150.501 155.599C149.464 156.921 148.107 158.147 146.79 159.227C147.317 159.21 147.781 159.12 148.307 159.103C149.823 158.944 151.121 158.332 152.344 158.244Z"
        fill="#00448A"
      />
    </g>
    <mask
      id="mask16_3690_7903"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="350"
      height="350"
    >
      <path d="M350 0H0V350H350V0Z" fill="white" />
    </mask>
    <g mask="url(#mask16_3690_7903)">
      <path
        d="M193.431 124.078C192.535 123.657 190.98 123.192 189.874 123.366C192.879 128.701 193.425 134.975 190.941 140.452C188.565 145.69 186.133 150.902 183.646 156.087C181.458 160.649 173.951 171.953 173.231 173.197C172.51 174.442 172.114 175.955 172.531 177.331C172.567 177.448 172.614 177.571 172.714 177.641C172.852 177.737 173.039 177.701 173.201 177.655C175.968 176.863 177.936 174.455 179.548 172.07C182.974 167.001 186.909 162.276 190.522 157.333C196.117 149.68 201.756 140.277 198.709 130.503C197.914 127.953 196.016 125.291 193.431 124.078Z"
        fill="#0072A6"
      />
    </g>
    <mask
      id="mask17_3690_7903"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="350"
      height="350"
    >
      <path d="M350 0H0V350H350V0Z" fill="white" />
    </mask>
    <g mask="url(#mask17_3690_7903)">
      <path
        d="M191.093 154.217C192.694 151.489 195.36 146.183 197.902 152.477C198.111 152.994 198.247 153.537 198.364 154.083C198.738 155.84 199.377 157.54 200.25 159.11C198.854 159.333 197.403 159.489 196.044 159.098C194.685 158.707 193.432 157.647 193.211 156.251C192.297 157.201 189.614 159.408 187.786 160.905C187.498 161.141 187.103 160.79 187.302 160.475C188.557 158.49 190.324 155.527 191.093 154.217Z"
        fill="#00448A"
      />
    </g>
    <mask
      id="mask18_3690_7903"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="350"
      height="350"
    >
      <path d="M350 0H0V350H350V0Z" fill="white" />
    </mask>
    <g mask="url(#mask18_3690_7903)">
      <path
        d="M169.554 53.3572C182.517 53.3572 193.026 42.8485 193.026 29.8854C193.026 16.9223 182.517 6.41357 169.554 6.41357C156.591 6.41357 146.082 16.9223 146.082 29.8854C146.082 42.8485 156.591 53.3572 169.554 53.3572Z"
        fill="#3C0000"
      />
      <path
        d="M169.554 105.557C190.239 105.557 207.008 88.6172 207.008 67.7211C207.008 46.8249 190.239 29.8853 169.554 29.8853C148.869 29.8853 132.101 46.8249 132.101 67.7211C132.101 88.6172 148.869 105.557 169.554 105.557Z"
        fill="#3C0000"
      />
      <path
        d="M197.851 99.8044C197.306 100.047 196.728 100.224 196.12 100.324C196.772 98.2195 198.521 85.1586 198.521 85.1586C198.898 80.6108 201.937 79.3955 203.7 81.0143C205.416 82.5908 204.999 86.7014 204.448 89.3294C203.888 92.0001 202.985 94.7072 201.332 96.9192C200.411 98.1511 199.238 99.1872 197.851 99.8044Z"
        fill="#B86121"
      />
      <path
        d="M140.7 87.1359C140.706 87.1243 140.71 87.1128 140.715 87.1011C140.668 87.0872 140.7 87.1359 140.7 87.1359Z"
        fill="#733127"
      />
      <path
        d="M141.267 99.8044C141.811 100.047 142.389 100.224 142.997 100.324C142.346 98.2195 140.597 85.1586 140.597 85.1586C140.219 80.6108 137.18 79.3955 135.418 81.0143C133.701 82.5908 134.118 86.7014 134.669 89.3294C135.229 92.0001 136.133 94.7072 137.786 96.9192C138.706 98.1511 139.879 99.1872 141.267 99.8044Z"
        fill="#B86121"
      />
      <path
        d="M198.391 87.1011C198.341 86.9922 198.298 86.8837 198.251 86.7751C198.038 86.2823 197.851 85.7916 197.687 85.3031C197.686 85.3005 197.685 85.2979 197.684 85.2953C197.603 85.0548 197.528 84.8148 197.458 84.5754C197.456 84.5667 197.454 84.558 197.451 84.5492C197.382 84.3121 197.319 84.0756 197.26 83.8395C197.26 83.8392 197.26 83.8389 197.26 83.8386C196.963 82.64 196.79 81.454 196.705 80.2811C196.669 79.7872 196.648 79.2954 196.639 78.8059C196.639 78.8047 196.639 78.8033 196.639 78.8021C196.63 78.3137 196.634 77.8275 196.646 77.3436C196.646 77.3409 196.646 77.3382 196.646 77.3354C196.659 76.855 196.68 76.3768 196.707 75.9008C196.707 75.8935 196.707 75.8863 196.708 75.8792C196.735 75.4102 196.767 74.9434 196.803 74.4787C196.804 74.4616 196.805 74.4445 196.806 74.4274C196.839 73.9968 196.874 73.5685 196.91 73.1416C197.091 70.9466 197.273 68.7992 197.151 66.6981C197.151 66.6975 197.151 66.6968 197.151 66.6962C197.146 66.6067 197.137 66.5174 197.131 66.4281C197.131 66.4277 197.131 66.4272 197.131 66.4268C197.105 66.0644 197.072 65.703 197.026 65.3435C197.026 65.3432 197.026 65.3431 197.026 65.3428C197.021 65.3066 197.014 65.2706 197.01 65.2344C197.01 65.234 197.009 65.2338 197.009 65.2333C196.955 64.8313 196.889 64.4307 196.804 64.0321C196.761 63.8339 196.714 63.6324 196.664 63.4286C196.664 63.4278 196.664 63.4273 196.664 63.4265C196.663 63.4248 196.663 63.4232 196.662 63.4215C196.588 63.1225 196.504 62.8171 196.412 62.5078C196.402 62.4748 196.393 62.4423 196.383 62.4093C196.291 62.1081 196.19 61.8025 196.081 61.4934C196.064 61.4467 196.047 61.4001 196.03 61.3532C195.917 61.0389 195.795 60.7219 195.662 60.4016C195.654 60.3823 195.645 60.3631 195.637 60.3438C195.503 60.025 195.359 59.7039 195.205 59.3809C195.192 59.3541 195.18 59.3274 195.167 59.3005C195.011 58.9777 194.844 58.6533 194.667 58.3283C194.64 58.2798 194.614 58.2314 194.587 58.1827C194.406 57.8568 194.216 57.5307 194.014 57.2045C193.996 57.1765 193.977 57.1484 193.96 57.1204C193.752 56.7897 193.534 56.4596 193.302 56.1306C193.293 56.1178 193.285 56.1051 193.276 56.0924C193.044 55.7643 192.797 55.438 192.54 55.1133C192.505 55.0683 192.469 55.0232 192.433 54.9781C192.175 54.6578 191.906 54.3398 191.624 54.0248C191.595 53.9928 191.565 53.9611 191.536 53.9292C190.948 53.2817 190.304 52.6488 189.603 52.0366C189.559 51.9986 189.517 51.9606 189.473 51.9232C189.129 51.6269 188.771 51.3361 188.398 51.0514C188.355 51.018 188.31 50.9855 188.266 50.9524C187.493 50.3695 186.659 49.8131 185.76 49.2894C185.71 49.2599 185.66 49.2298 185.609 49.2006C185.169 48.9483 184.714 48.7048 184.243 48.4693C184.181 48.4381 184.118 48.4078 184.055 48.3769C182.347 47.5392 180.441 46.8147 178.304 46.249C175.44 45.4906 172.497 45.1115 169.553 45.1118C166.61 45.1115 163.666 45.4906 160.802 46.249C148.385 49.5362 143.568 58.0957 142.303 64.0321C140.883 70.6934 144.021 77.83 141.357 85.4952C141.35 85.5085 141.343 85.524 141.337 85.5366C141.097 85.984 140.93 86.4318 140.81 86.8804C140.778 86.9541 140.749 87.0275 140.715 87.1011C140.724 87.1034 140.734 87.1077 140.747 87.1141C140.218 89.4428 141.048 91.8041 141.314 94.3275C141.516 96.2476 141.735 98.1668 141.989 100.081C143.097 106.988 148.05 111.269 150.969 113.716C156.111 118.028 163.122 122.785 169.082 122.907C169.082 122.907 169.379 122.913 169.579 122.913C169.811 122.913 170.028 122.907 170.028 122.907C170.724 122.893 171.434 122.809 172.153 122.677C172.168 122.675 172.183 122.672 172.198 122.669C172.54 122.605 172.883 122.53 173.229 122.443C173.231 122.442 173.234 122.442 173.236 122.441C173.474 122.381 173.713 122.315 173.952 122.244C173.953 122.244 173.954 122.244 173.955 122.244C173.969 122.239 173.983 122.235 173.997 122.231C174.953 121.945 175.918 121.579 176.882 121.147C176.883 121.147 176.883 121.147 176.884 121.146C176.886 121.145 176.888 121.144 176.891 121.143C176.892 121.143 176.893 121.142 176.894 121.142C177.195 121.006 177.497 120.865 177.798 120.718C177.799 120.717 177.8 120.717 177.801 120.717C178.709 120.273 179.612 119.778 180.504 119.245C180.505 119.244 180.505 119.244 180.506 119.244C180.506 119.243 180.507 119.243 180.508 119.242C180.508 119.242 180.509 119.242 180.51 119.241C181.836 118.448 183.136 117.577 184.381 116.669C184.4 116.655 184.417 116.639 184.435 116.625C184.436 116.625 184.437 116.624 184.437 116.624C187.419 114.446 190.088 112.082 192.06 110.208C193.118 109.202 196.16 106.308 197.034 100.105C197.087 99.7239 197.14 99.3428 197.192 98.9612C197.467 96.918 197.714 94.8708 197.929 92.8202C198.064 91.5275 198.186 90.2335 198.285 88.9375C198.33 88.3498 198.445 87.7091 198.337 87.1261C198.361 87.1127 198.379 87.1047 198.391 87.1011Z"
        fill="#B86121"
      />
    </g>
    <path
      d="M141.878 75.459L135.954 80.2352L136.07 80.5705C136.07 80.5705 137.827 79.7206 139.118 81.2708C139.363 81.565 142.256 78.5164 142.256 78.5164L141.878 75.459Z"
      fill="#FF612B"
    />
    <path
      d="M197.224 75.459L203.148 80.2352L203.031 80.5705C203.031 80.5705 201.275 79.7206 199.984 81.2708C199.739 81.565 196.846 78.5164 196.846 78.5164L197.224 75.459Z"
      fill="#FF612B"
    />
    <path
      d="M167.276 78.9962C167.03 75.8902 163.414 73.9819 160.758 73.3996C155.996 72.3557 150.39 73.1684 145.704 74.2615C145.328 74.3491 141.85 74.9006 141.826 75.3918L141.71 77.7015C141.693 78.0354 141.95 78.3197 142.284 78.3365L143.83 78.8088C143.793 83.4844 145.462 90.7753 150.85 92.0081C154.921 92.9397 159.932 92.751 163.095 89.6834C165.746 87.1121 166.837 83.223 167.255 79.701C167.283 79.4671 167.295 79.2311 167.276 78.9962ZM164.675 80.1827C164.534 82.1501 164.232 84.1236 163.249 85.8333C161.543 88.798 158.355 90.5124 154.943 90.438C152.768 90.3906 150.4 89.6015 148.828 88.0593C147.945 87.1921 147.298 86.179 146.845 85.0807C146.336 83.8481 146.073 82.5079 145.993 81.1459C145.862 78.8954 146.974 76.778 149.14 75.9762C151.87 74.9653 155.441 75.0215 158.298 75.3245C161.139 75.6257 164.927 76.6459 164.675 80.1827Z"
      fill="#FF612B"
    />
    <path
      d="M172.251 78.298C171.503 77.5044 170.491 77.0676 169.402 77.0679C168.314 77.0682 167.302 77.5055 166.554 78.2995L164.93 76.7685C166.087 75.5408 167.717 74.8364 169.402 74.8359C171.086 74.8355 172.717 75.539 173.875 76.7661L172.251 78.298Z"
      fill="#FF612B"
    />
    <path
      opacity="0.2"
      d="M182.44 75.1382L174.801 82.4343C174.964 83.4725 175.241 84.4834 175.722 85.4272C176.235 86.4338 176.928 87.2978 177.734 88.0267L188.943 75.8278C186.902 75.2438 184.558 75.0935 182.44 75.1382Z"
      fill="white"
    />
    <path
      opacity="0.2"
      d="M179.73 89.4012C180.513 89.7998 181.349 90.0921 182.227 90.262L193.033 79.5266C192.797 78.6279 192.346 77.8112 191.666 77.1797L179.73 89.4012Z"
      fill="white"
    />
    <path
      d="M197.058 75.5283C196.552 75.1868 195.131 74.7831 194.235 74.55C193.871 74.4555 193.595 74.389 193.502 74.3663C192.64 74.1556 191.74 73.9606 190.827 73.7783C188.844 73.3826 186.773 73.0828 184.71 72.9699C182.568 72.8526 180.441 72.931 178.458 73.3436C175.795 73.8976 172.159 75.7671 171.88 78.8703C171.859 79.105 171.868 79.341 171.893 79.5753C172.06 81.1205 172.368 82.7333 172.867 84.2812C173.508 86.2658 174.473 88.1411 175.947 89.6015C176.007 89.6613 176.079 89.7031 176.141 89.7608C176.724 90.3055 177.371 90.7453 178.058 91.1131C178.808 91.5145 179.6 91.829 180.432 92.0456C182.942 92.6996 185.718 92.5896 188.166 92.0569C193.567 90.8817 195.314 83.609 195.326 78.9333L196.758 78.689C197.092 78.6758 197.352 78.3943 197.339 78.0602L197.248 75.7494C197.245 75.6809 197.173 75.6061 197.058 75.5283ZM193.193 81.6229C193.045 82.9791 192.713 84.3041 192.143 85.5093C191.635 86.5832 190.937 87.5621 190.01 88.3832C188.363 89.8436 185.957 90.5113 183.783 90.4481C183.254 90.4328 182.737 90.3603 182.227 90.2618C181.349 90.0919 180.513 89.7996 179.73 89.401C179.007 89.0322 178.337 88.5724 177.734 88.0267C176.929 87.2978 176.235 86.4338 175.722 85.4272C175.241 84.4834 174.964 83.4725 174.801 82.4343C174.661 81.5394 174.603 80.6244 174.585 79.7115C174.512 76.1664 178.348 75.3401 181.2 75.1836C181.601 75.1616 182.017 75.1472 182.44 75.1382C184.559 75.0935 186.902 75.2438 188.943 75.8278C189.417 75.9633 189.88 76.1139 190.314 76.2999C190.833 76.5228 191.283 76.8231 191.666 77.1795C192.346 77.811 192.797 78.6277 193.033 79.5264C193.208 80.1933 193.272 80.9019 193.193 81.6229Z"
      fill="#FF612B"
    />
    <path
      opacity="0.2"
      d="M153.755 75.297L146.144 82.829C146.338 83.8583 146.647 84.8565 147.164 85.7811C147.714 86.767 148.446 87.6047 149.288 88.3039L160.418 75.7637C158.317 75.2508 155.919 75.1806 153.755 75.297Z"
      fill="white"
    />
    <path
      opacity="0.2"
      d="M151.364 89.606C152.174 89.9768 153.037 90.2397 153.938 90.3793L164.694 79.3116C164.429 78.4237 163.947 77.625 163.236 77.0186L151.364 89.606Z"
      fill="white"
    />
  </Box>
)
export default OBGYNDoctor
